/**
 * Buggino – product form: maps option swatches to the hidden variant select,
 * updates price, availability, URL and notifies the gallery
 * (document event "variant:change").
 */
(function () {
  'use strict';

  const formatMoney = (cents, format) =>
    window.Buggino && window.Buggino.formatMoney
      ? window.Buggino.formatMoney(cents, format)
      : (cents / 100).toFixed(2).replace('.', ',') + ' €';

  function initRoot(root) {
    const jsonNode = root.querySelector('[data-variants-json]');
    const select = root.querySelector('[data-variant-select]');
    if (!jsonNode || !select) return;

    let variants = [];
    try {
      variants = JSON.parse(jsonNode.textContent);
    } catch (error) {
      return;
    }

    const moneyFormat = root.dataset.moneyFormat || '';
    const optionGroups = Array.from(root.querySelectorAll('[data-option-index]'));
    const addButton = root.querySelector('[data-add-to-cart]');
    const addLabel = root.querySelector('[data-add-label]');
    const priceCurrent = root.querySelector('.price__current');
    const priceWrap = root.querySelector('.price');
    const i18n = (name) => {
      const el = root.querySelector(`[data-i18n-${name}]`);
      return el ? el.textContent : '';
    };

    function selectedOptions() {
      return optionGroups.map((group) => {
        const checked = group.querySelector('[data-option-input]:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(options) {
      return variants.find((variant) => options.every((value, index) => variant.options[index] === value));
    }

    function updateAvailabilityOfInputs(options) {
      // For each option group mark values that have no available variant given the other selections.
      optionGroups.forEach((group, groupIndex) => {
        group.querySelectorAll('[data-option-input]').forEach((input) => {
          const trial = options.slice();
          trial[groupIndex] = input.value;
          const match = variants.find((variant) => trial.every((value, i) => value === null || variant.options[i] === value));
          const available = Boolean(match && match.available);
          input.toggleAttribute('data-unavailable', !available);
          const label = input.closest('.swatch');
          if (label) label.classList.toggle('swatch--unavailable', !available);
        });
      });
    }

    function renderPrice(variant) {
      if (!priceCurrent) return;
      priceCurrent.textContent = formatMoney(variant.price, moneyFormat);
      let compare = root.querySelector('.price__compare');
      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (onSale) {
        if (!compare) {
          compare = document.createElement('s');
          compare.className = 'price__compare';
          priceWrap.appendChild(compare);
        }
        compare.textContent = formatMoney(variant.compare_at_price, moneyFormat);
      } else if (compare) {
        compare.remove();
      }
      if (priceWrap) priceWrap.classList.toggle('price--sale', Boolean(onSale));
    }

    function apply(variant) {
      if (!variant) {
        if (addButton) {
          addButton.setAttribute('disabled', '');
          if (addLabel) addLabel.textContent = i18n('unavailable');
        }
        return;
      }
      select.value = String(variant.id);
      renderPrice(variant);

      if (addButton) {
        addButton.toggleAttribute('disabled', !variant.available);
        if (addLabel) addLabel.textContent = variant.available ? i18n('add') : i18n('sold-out');
      }

      optionGroups.forEach((group, index) => {
        const label = group.querySelector('[data-option-value]');
        if (label) label.textContent = variant.options[index];
      });

      if (window.history && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      document.dispatchEvent(
        new CustomEvent('variant:change', {
          detail: { variant, mediaId: variant.featured_media ? variant.featured_media.id : null },
        })
      );
    }

    root.addEventListener('change', (event) => {
      if (!event.target.matches('[data-option-input]')) return;
      const options = selectedOptions();
      updateAvailabilityOfInputs(options);
      apply(findVariant(options));
    });

    updateAvailabilityOfInputs(selectedOptions());
  }

  function init() {
    document.querySelectorAll('[data-product-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
